import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { Box, Typography, CircularProgress, TextField } from "@mui/material";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import { chargesTableColumns } from "../../../data/FormColumns/Fleet/chargesTableColumns";
import PersistedDataGrid from "../../PersistedDataGrid/PersistedDataGrid";

const fetchCharges = async (token: string | null | undefined) => {
  const { data } = await axios.get(`${apiVariable}/charges`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

const ChargesTable: React.FC = () => {
  const { token } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["charges"],
    queryFn: () => fetchCharges(token),
  });

  const filteredCharges = useMemo(() => {
    if (!data) return [];
    return data.filter((charge: any) =>
      [
        charge.driverName,
        charge.ownerCompanyName,
        charge.reason,
        charge.caseNumber,
      ].some((field) =>
        field?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [data, searchTerm]);

  return (
    <>
      <Box className="incidents-table-container" height={900}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by Driver, Company, Reason or Case Number"
            sx={{ maxWidth: "100%", width: 400 }}
          />
        </Box>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error">Error: {(error as any).message}</Typography>
        ) : (
          <PersistedDataGrid
            tableName="charges"
            rows={filteredCharges}
            columns={chargesTableColumns}
            sx={{ height: 700 }}
          />
        )}
      </Box>
    </>
  );
};

export default ChargesTable;
